export default __webpack_public_path__ + "static/media/jm.bd7d859f.svg";